// Header Component
const appName = "GDS Axon";
const appSubTitle = "Service Manager";
// Session timeout constants
const sessionTimeoutTitle = "Your session is about to expire";
const sessionTimeoutMessage =
  "You're being timed out due to inactivity. Please choose to stay signed in or signed out. Otherwise, you will be signed out automatically in $1 minute(s).";
const sessionTimeoutStayLoggedIn = "Stay signed in";
const sessionTimeoutLogOut = "Sign out now";

export {
  appName,
  sessionTimeoutTitle,
  sessionTimeoutMessage,
  sessionTimeoutStayLoggedIn,
  sessionTimeoutLogOut,
  appSubTitle,
};
